export enum Exchange {
  HUOBI = 'HUOBI',
  FIREBLOCKS = 'FIREBLOCKS',
  OK_COIN = 'OK_COIN',
  OKEX = 'OKEX',
  BINANCE = 'BINANCE',
  BITFINEX = 'BITFINEX',
  LIQUID = 'LIQUID',
  CROSS_TOWER = 'CROSS_TOWER',
  GATE_IO = 'GATE_IO',
  KU_COIN = 'KU_COIN',
  BYBIT = 'BYBIT',
  FINERY_MARKETS = 'FINERY_MARKETS',
  CYPATOR = 'CYPATOR'

}
